import { useState, useContext, useEffect } from 'react';
import { UserContext } from '../context/UserContext';
import APP_VERSION from '../version';
import { getHomePath } from '../utils/site';
import './intro.css';

const Intro = () => {
  const { user, login } = useContext(UserContext);
  const [id, setId] = useState('');
  const [passwd, setPasswd] = useState('');
  
  useEffect(() => {
    document.body.classList.add('intro-page');

    const clearBlockingLayers = () => {
      document.body.classList.remove('ReactModal__Body--open');
      document.body.classList.remove('has-dialog-open');

      document.querySelectorAll('.ReactModal__Overlay, .ReactModalPortal').forEach((el) => el.remove());

      Array.from(document.body.children).forEach((el) => {
        if (el.id === 'root') return;

        const className = (el.className || '').toString();
        const style = window.getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        const coversViewport = rect.width >= window.innerWidth * 0.9 && rect.height >= window.innerHeight * 0.9;
        const isLikelyOverlay = /overlay|modal|backdrop/i.test(className) || (style.position === 'fixed' && coversViewport);

        if (isLikelyOverlay) {
          el.remove();
        }
      });
    };

    clearBlockingLayers();
    const intervalId = window.setInterval(clearBlockingLayers, 700);

    if (user && user.user_id) {
      // manager 는 이번회차 고사장설정, branch 는 회차별 고사장현황으로 들어간다.
      window.location.href = getHomePath();
    }

    return () => {
      window.clearInterval(intervalId);
      document.body.classList.remove('intro-page');
    };
  }, [user]);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!id || id === '') {
      alert('아이디를 입력해주세요.');
      return;
    }
    
    if (!passwd || passwd === '') {
      alert('비밀번호를 입력해주세요.');
      return;
    }

    login(id, passwd);
  }

  return (
    <div id="intro">
      <div className="head">
        <h1>한국실용글쓰기검정</h1>
        <h2>지역본부 <span className="version">v{APP_VERSION}</span></h2>
      </div>
      <div className="body">
        <p>지역본부로 등록된 사용자만 접근할 수 있습니다.</p>
        <p>협회나 지역본부에 등록여부를 확인 바랍니다.</p>
        <form onSubmit={handleLogin}>
          <ul className="form">
            <li>
              <label htmlFor="userId">아&nbsp;&nbsp;이&nbsp;&nbsp;디</label>
              <span>
                <input 
                  type="text" 
                  id="userId"
                  name="userId"
                  value={id} 
                  onChange={(e) => setId(e.target.value)}
                  autoComplete="username"
                  placeholder="아이디를 입력하세요"
                />
              </span>
            </li>
            <li>
              <label htmlFor="userPassword">비밀번호</label>
              <span>
                <input 
                  type="password" 
                  id="userPassword"
                  name="userPassword"
                  value={passwd} 
                  onChange={(e) => setPasswd(e.target.value)}
                  autoComplete="current-password"
                  placeholder="비밀번호를 입력하세요"
                />
              </span>
            </li>
            <li>
              <button type="submit" className='login' disabled={!id || !passwd}>
                로그인
              </button>
            </li>
            <li>
              <button type="button" onClick={() => alert('서비스 준비중입니다.')}>
                아이디찾기
              </button>
              <button type="button" onClick={() => alert('서비스 준비중입니다.')}>
                비밀번호찾기
              </button>
            </li>
          </ul>
        </form>
      </div>
    </div>
  );
};

export default Intro;